import { render, staticRenderFns } from "./CommentItemSkeleton.vue?vue&type=template&id=f7f64f70&scoped=true&"
var script = {}
import style0 from "./CommentItemSkeleton.vue?vue&type=style&index=0&id=f7f64f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f64f70",
  null
  
)

export default component.exports